<ng-template #content let-modal>

    <div class="modal-header bg-dark">
        <h5 class="modal-title" id="changeStateLabel">Cambiar estado</h5>
        <button type="button" class="close text-light" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="changeStateForm">
        <input type="hidden" class="form-control" id="InputPedido" name="InputPedido"
            [formControl]="changeStateForm.get('id_pedido')">
        <div class="modal-body">
            <div class="row justify-content-center">
                <div class="col-md-5">
                    <app-input type="text" label="Estado actual" size="lg" idForm="InputEstadoActual" [readOnly]="true"
                        [autocomplete]="false" [control]="changeStateForm.get('estado_old_text')"></app-input>
                    <input type="hidden" class="form-control" id="InputEstadoActualText" name="InputEstadoActualText"
                        [formControl]="changeStateForm.get('estado_old')">
                </div>
                <div class="col-md-5">
                    <app-select label="Nuevo Estado" size="lg" idForm="InputNewState" [data]="estados"
                        optValue="id_estado" optText="nombre_estado"
                        [control]="changeStateForm.get('estado_new')"></app-select>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="submit" name="add" class="btn btn-outline-success"
                (click)="modal.close(changeStateForm.value)" [disabled]="!changeStateForm.valid">
                <i class="fas fa-exchange-alt"></i> Actualizar
            </button>
            <button type="button" class="btn btn-outline-danger" (click)="modal.dismiss('close')"><i
                    class="fas fa-times"></i> Cancelar</button>
        </div>
    </form>
</ng-template>

<button type="button" class="btn btn-outline-secondary {{cssClass}}" title="Cambiar Estado" (click)="open(content)">
    <i class='fas fa-flag'></i>
</button>